<template>
  <div>
    <div class="row my-3">
      <div class="col-lg-4">
        <vue-select
          name="periodo"
          v-model="periodo"
          class="select-periodo"
          :clearable="true"
          :options="optionsPeriodo"
          label="label"
          placeholder="Periodo"
          @input="onChangePeriodo"
        >
          <template slot="option" slot-scope="option">
            {{ option.label }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
      <div class="col-lg-4">
        <vue-select
          name="indicador"
          v-model="indicador"
          class="select-indicador"
          :clearable="true"
          :options="optionsIndicador"
          label="label"
          placeholder="Indicador"
          @input="onChangeIndicador"
        >
          <template slot="option" slot-scope="option">
            {{ option.label }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
      <div class="col-lg-4">
        <download-files
          :pdfEnabled="false"
          :data="indexedItems"
          :fields="dataFields"
          name="diagnostico-situacional"
          class="float-right"
        >
        </download-files>
      </div>
    </div>
    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              class="input-bottom"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            @pagination="getPagination"
            :page="currentPage"
            :footer-props="{
              itemsPerPageText: '',
              'items-per-page-options': [10],
              'disable-items-per-page': true,
            }"
            :loading="loading"
            loading-text="Carregando, Por favor espere"
            :headers="headers"
            :items="indexedItems"
            :item-class="getRowColor"
            :search="search"
            :single-expand="true"
            :expanded.sync="expanded"
            item-key="id"
            class="elevation-1"
          >
            <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->

            <template v-slot:item.resultado="{ item }">
              {{ item.resultado }}%
            </template>

            <template v-slot:item.recomendacao_resultado="{ item }">
              {{ item.recomendacao_resultado }}
            </template>

            <!-- <template v-slot:expanded-item="{ headers, item }">

          </template> -->

            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <FonteEsusPecGlobal
                  :texto="texto_esus_pec"
                  :data="data_esus_pec"
                />
              </div>
              <span class="paginacao"
                >{{ items.pageStart }} - {{ items.pageStop }} de
                {{ items.itemsLength }} equipes</span
              >
            </template>

            <template v-slot:progress>
              <v-progress-linear
                color="blue"
                :height="10"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
              </div>
            </template>
            <template v-slot:no-results style="padding: 0px">
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>
  </div>
</template>

<script>
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import { dataFields } from './utils.js'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    DownloadFiles,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    texto_esus_pec: {
      type: String,
      default: '',
    },
    data_esus_pec: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'CNES',
          align: 'start',
          filterable: true,
          value: 'nu_cnes',
        },
        {
          text: 'UBS',
          align: 'start',
          filterable: true,
          value: 'no_unidade_saude',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: true,
          value: 'nu_ine',
        },
        {
          text: 'Equipe',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        {
          text: 'Cidadãos',
          align: 'start',
          filterable: true,
          value: 'cidadaos',
        },
        {
          text: 'Período',
          align: 'start',
          filterable: true,
          value: 'mes_ano',
        },
        {
          text: 'Indicador',
          align: 'start',
          filterable: true,
          value: 'no_indicador',
        },
        {
          text: 'Resultado',
          align: 'start',
          filterable: true,
          value: 'resultado',
        },
        {
          text: 'Atenção',
          align: 'start',
          filterable: true,
          value: 'recomendacao_resultado',
        },
        // { text: '', value: 'data-table-expand' },
      ],
      periodo: null,
      optionsPeriodo: [],
      indicador: null,
      optionsIndicador: [],
      dataFields: {
        ...dataFields,
      },
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
        const periodos = Array.from(
          new Set(this.cadastros.map((item) => item.mes_ano))
        )
        periodos.sort((a, b) => {
          // Divide cada string em mês e ano
          let [mesA, anoA] = a.split('/').map(Number)
          let [mesB, anoB] = b.split('/').map(Number)

          // Compara primeiro os anos
          if (anoA > anoB) return -1 // Inverte a comparação para decrescente
          if (anoA < anoB) return 1

          // Se os anos forem iguais, compara os meses
          return mesB - mesA // Inverte a comparação para decrescente
        })
        this.optionsPeriodo = periodos
        this.optionsIndicador = Array.from(
          new Set(this.cadastros.map((item) => item.no_indicador))
        )
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    indexedItems() {
      if (this.cadastros !== undefined) {
        return this.cadastros
          .filter((item) => {
            // Filtrar por indicador se selecionado
            const filterByIndicador = this.indicador
              ? item.no_indicador === this.indicador
              : true
            // Filtrar por período se selecionado
            const filterByPeriodo = this.periodo
              ? item.mes_ano === this.periodo
              : true
            return filterByIndicador && filterByPeriodo
          })
          .map((item, index) => {
            return {
              id: index,
              ...item,
            }
          })
      }
    },
  },
  methods: {
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    getPagination(options) {
      this.currentPage = options.page
    },

    getRowColor(item) {
      return `table-row-color-${Functions.printTableRow(item)}`
    },

    onChangePeriodo(periodo) {
      this.$emit('onChangePeriodo', periodo)
    },

    onChangeIndicador(indicador) {
      this.$emit('onChangeIndicador', indicador)
    },
  },
}
</script>

<style>
.tabela .green-color {
  color: green !important;
}
.tabela .red-color {
  color: red !important;
}
</style>
<style scoped lang="scss">
.ultimo-acompanhamento {
  display: flex;
  align-items: center;
  // flex-direction: column;
  gap: 10px;
  span {
    background: #c4e8f6;
    color: #00aeef;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 11px;
  }
}
</style>
